/** @jsx jsx */
import { jsx } from "@emotion/core"
import React from "react"
import { RouteComponentProps } from "@reach/router"
import { RichText } from "prismic-reactjs"
import { useEffect, useState } from "react"
import Button from "./Button"
import { Helmet } from "react-helmet"
import { MediaQuery, siteContentContainer } from "./constants"
import { EditableHomepageContent } from "./EditableContent.types"
import heroImageSourceUrl from "./images/hero.png"
import faqSectionBackgroundImageUrl from "./images/homepage-faq-section-background.png"
import { flexCenterChildren, column, row, fullWidth, yGap, Spacer } from "./layoutUtilities"
import prismicClient from "./prismicClient"
import Prismic from "prismic-javascript"

const Step1Graphic = () => (
  <svg width={100} height={100}>
    <g fillRule="nonzero" fill="none">
      <path fill="#F5F5FD" d="M17.249 1.465H82.75v48.622H17.25z" />
      <path fill="#DCDCE3" d="M78.805 1.465h3.946v48.622h-3.946z" />
      <path fill="#FD0" d="M24.746 8.962h18.94V36.19h-18.94z" />
      <path fill="#00C389" d="M50.79 8.962h24.464v6.708H50.79z" />
      <g>
        <path
          d="M94.59 84.417H5.41a3.946 3.946 0 0 1-3.945-3.946V54.033a3.946 3.946 0 0 1 3.946-3.946h89.178a3.946 3.946 0 0 1 3.946 3.946V80.47a3.946 3.946 0 0 1-3.946 3.946z"
          fill="#00C389"
        />
        <path
          d="M94.59 50.087h-5.92a3.946 3.946 0 0 1 3.946 3.946V80.47a3.946 3.946 0 0 1-3.946 3.946h5.92a3.946 3.946 0 0 0 3.945-3.946V54.033a3.946 3.946 0 0 0-3.946-3.946z"
          fill="#00A876"
        />
        <path fill="#D8E2F1" d="M87.123 87.123l11.412-6.668-27.874-9.794 9.794 27.874z" />
      </g>
      <g fill="#000">
        <path d="M43.687 7.497H24.746c-.81 0-1.465.656-1.465 1.465V36.19c0 .81.656 1.465 1.465 1.465h18.94c.81 0 1.465-.656 1.465-1.465V8.962c0-.81-.655-1.465-1.464-1.465zm-1.465 27.227H26.21V10.427h16.01v24.297zM50.79 17.135h24.464c.81 0 1.465-.656 1.465-1.465V8.962c0-.81-.656-1.465-1.465-1.465H50.79c-.809 0-1.465.656-1.465 1.465v6.708c0 .81.656 1.465 1.465 1.465zm1.464-6.708H73.79v3.778H52.254v-3.778zM50.79 24.238h24.464a1.465 1.465 0 1 0 0-2.93H50.79a1.465 1.465 0 1 0 0 2.93zM50.79 30.551h24.464a1.465 1.465 0 1 0 0-2.93H50.79a1.465 1.465 0 1 0 0 2.93zM50.79 37.654h24.464a1.465 1.465 0 1 0 0-2.93H50.79a1.465 1.465 0 1 0 0 2.93zM37.487 43.292c0 .809.655 1.465 1.464 1.465h36.303a1.465 1.465 0 1 0 0-2.93H38.951c-.809 0-1.464.656-1.464 1.465zM24.746 44.757h7.103a1.465 1.465 0 1 0 0-2.93h-7.103a1.465 1.465 0 1 0 0 2.93zM44.582 58.98H40.63c-.81 0-1.465.656-1.465 1.466v13.612a1.465 1.465 0 0 0 1.465 1.464h.006s3.636-.016 4.638-.016a5.125 5.125 0 1 0 3.044-9.253 4.57 4.57 0 0 0 .862-2.675 4.602 4.602 0 0 0-4.597-4.597zm0 2.93c.92 0 1.668.748 1.668 1.668a1.67 1.67 0 0 1-1.668 1.667l-1.47.004h-1.019V61.91h2.49zm.69 10.667c-.58 0-2.047.005-3.179.01v-4.404l1.027-.004h2.153c1.213 0 2.2.986 2.2 2.199a2.202 2.202 0 0 1-2.2 2.199zM16.677 65.985a72.476 72.476 0 0 1-3.746-1.515 1.175 1.175 0 0 1-.446-1.124c.041-.285.245-.981 1.249-1.284 2.044-.616 3.914.87 3.964.91a1.465 1.465 0 0 0 1.879-2.248c-.125-.105-3.09-2.55-6.688-1.467-1.79.54-3.056 1.947-3.304 3.672a4.092 4.092 0 0 0 1.825 4.051c.065.043.133.08.203.111.079.035 1.947.866 4.05 1.642.653.241 2.148.93 1.936 2.117-.153.857-1.171 1.743-2.61 1.743-1.42 0-2.787-.574-3.659-1.537a1.465 1.465 0 1 0-2.17 1.968c1.418 1.565 3.596 2.499 5.828 2.499 2.754 0 5.065-1.749 5.495-4.158.322-1.803-.509-4.164-3.806-5.38zM24.941 58.98c-.809 0-1.464.656-1.464 1.466v9.366c0 1.996.92 3.553 2.811 4.763.982.627 2.091.946 3.296.948h.01c1.04 0 2.015-.226 2.9-.672 2.786-1.403 3.371-3.52 3.371-5.049v-9.356a1.465 1.465 0 1 0-2.93 0v9.356c0 .72-.2 1.647-1.76 2.433a3.482 3.482 0 0 1-1.582.358h-.005a3.11 3.11 0 0 1-1.722-.487c-1.037-.663-1.46-1.327-1.46-2.294v-9.366c0-.81-.655-1.465-1.465-1.465z" />
        <path d="M100 54.033a5.417 5.417 0 0 0-5.41-5.412H84.216V1.465c0-.81-.655-1.465-1.465-1.465H17.25c-.81 0-1.465.656-1.465 1.465v14.334a1.465 1.465 0 1 0 2.93 0V2.93h62.572v45.692h-1.725a1.465 1.465 0 1 0 0 2.93H94.59a2.484 2.484 0 0 1 2.48 2.482v24.354l-9.898-3.478c.172-.24.274-.533.274-.851V61.91h2.31a1.465 1.465 0 1 0 0-2.93h-7.518a1.465 1.465 0 1 0 0 2.93h2.279v12.066l-7.108-2.497V60.445a1.465 1.465 0 1 0-2.93 0V70.45l-3.332-1.171a1.46 1.46 0 0 0-.91-.017L68.543 60.4a1.773 1.773 0 0 0-3.422-.193l-.016.05-2.662 9.339-2.76-9.354a1.772 1.772 0 0 0-3.44.194l-2.392 13.256a1.465 1.465 0 0 0 2.884.52l1.524-8.446 2.507 8.498.017.052a1.77 1.77 0 0 0 1.68 1.208h.009a1.769 1.769 0 0 0 1.692-1.276l2.42-8.492 1.62 8.472a1.465 1.465 0 0 0 2.437.795l2.786 7.93H21.502a1.465 1.465 0 1 0 0 2.929h52.954l4.617 13.14a1.464 1.464 0 0 0 2.647.253l6.474-11.08 3.959-2.313h2.437c2.959 0 5.37-2.388 5.408-5.354v-.002l.002-.07V54.033zM86.384 85.86a1.467 1.467 0 0 0-.525.525l-5.072 8.679-7.732-22.008 22.008 7.732-8.679 5.072z" />
        <path d="M14.664 82.951H5.41a2.483 2.483 0 0 1-2.48-2.48V54.033a2.484 2.484 0 0 1 2.48-2.482h67.302a1.465 1.465 0 1 0 0-2.93H18.713V22.643a1.465 1.465 0 1 0-2.93 0v25.978H5.41A5.417 5.417 0 0 0 0 54.033v26.438a5.416 5.416 0 0 0 5.41 5.41h9.254a1.465 1.465 0 1 0 0-2.93z" />
      </g>
    </g>
  </svg>
)

const Step2Graphic = () => (
  <svg width={100} height={94}>
    <g fillRule="nonzero" fill="none">
      <path
        fill="#00C389"
        d="M43.333 31.667H90v20H43.333zM50 51.667h48.333v20H50zM51.667 71.667H95v20H51.667z"
      />
      <path
        d="M55 91.667H1.667v-4.31c0-1.51.6-2.957 1.666-4.024A5.69 5.69 0 0 0 5 79.31V55c0-8.284 6.716-15 15-15h16.667c8.284 0 15 6.716 15 15v26.667l1.666 1.666A5.69 5.69 0 0 1 55 87.357v4.31z"
        fill="#F6F7FE"
      />
      <path
        d="M35 40l1.476-3.691a25.963 25.963 0 0 0 1.857-9.642h-20c0 3.303.63 6.575 1.857 9.642L21.667 40H35z"
        fill="#E0E1E7"
      />
      <path fill="#F6F7FE" d="M65 71.667h13.333v20H65z" />
      <path
        d="M75 11.667A6.667 6.667 0 0 0 81.667 5V1.667H95V5a6.667 6.667 0 0 1-6.667 6.667H75z"
        fill="#00C389"
      />
      <path
        d="M51.667 81.667h-8.334V55a6.667 6.667 0 0 0-6.666-6.667A8.333 8.333 0 0 1 28.333 40h8.334c8.284 0 15 6.716 15 15v26.667z"
        fill="#E0E1E7"
      />
      <path fill="#F6F7FE" d="M68.333 51.667h13.334v20H68.333zM60 31.667h13.333v20H60z" />
      <path fill="#00C389" d="M48.333 11.667H95v20H48.333z" />
      <path fill="#F6F7FE" d="M65 11.667h13.333v20H65z" />
      <path
        d="M1.667 93.333H55a1.667 1.667 0 0 0 1.667-1.666v-4.31a7.308 7.308 0 0 0-2.155-5.202l-1.179-1.179V55c-.01-8.894-6.995-16.217-15.88-16.647l.57-1.425A27.508 27.508 0 0 0 40 26.667 1.667 1.667 0 0 0 38.333 25h-20a1.667 1.667 0 0 0-1.666 1.667 27.508 27.508 0 0 0 1.976 10.261l.57 1.425c-8.884.43-15.869 7.753-15.88 16.647v24.31a3.997 3.997 0 0 1-1.178 2.845A7.309 7.309 0 0 0 0 87.357v4.31a1.667 1.667 0 0 0 1.667 1.666zm34.943-65a24.172 24.172 0 0 1-1.681 7.357l-1.057 2.643H22.795l-1.057-2.643a24.172 24.172 0 0 1-1.681-7.357H36.61zM3.333 87.357a3.997 3.997 0 0 1 1.179-2.845 7.309 7.309 0 0 0 2.155-5.202V55C6.675 47.64 12.64 41.675 20 41.667h16.667C44.027 41.675 49.992 47.64 50 55v25h-6.667v3.333h7.643l1.179 1.179a3.997 3.997 0 0 1 1.178 2.845V90h-50v-2.643z"
        fill="#000"
      />
      <path
        d="M29.072 65h-3.334a2.5 2.5 0 0 1 0-5h6.667v-3.333h-3.333v-3.334h-3.334v3.334a5.833 5.833 0 0 0 0 11.666h3.334a2.5 2.5 0 0 1 0 5h-8.334v3.334h5v2.656h3.334v-2.656a5.833 5.833 0 0 0 0-11.667zM98.333 50h-6.666V33.333H95a1.667 1.667 0 0 0 1.667-1.666v-20A1.667 1.667 0 0 0 95 10h-.005a8.29 8.29 0 0 0 1.672-5V1.667A1.667 1.667 0 0 0 95 0H81.667A1.667 1.667 0 0 0 80 1.667V5a5.006 5.006 0 0 1-5 5H48.333a1.667 1.667 0 0 0-1.666 1.667V30h-3.334a1.667 1.667 0 0 0-1.666 1.667v5H45v-3.334h13.333v3.334h-10V40h10v3.333h-5v3.334h5V50h-1.666v3.333h10v3.334H60V60h6.667v3.333H60v3.334h6.667V70H55v3.333h8.333v3.334H60V80h3.333v3.333H60v3.334h3.333V90h-5v3.333H95a1.667 1.667 0 0 0 1.667-1.666V73.333h1.666A1.667 1.667 0 0 0 100 71.667v-20A1.667 1.667 0 0 0 98.333 50zm-1.666 6.667H83.333v-3.334h13.334v3.334zM80 80h13.333v3.333H80V80zm3.333-20h13.334v3.333H83.333V60zM75 50v-3.333h13.333V50H75zm13.333-6.667H75V40h13.333v3.333zm0-6.666H75v-3.334h13.333v3.334zm5-23.334v3.334H80v-3.334h13.333zM80 20h13.333v3.333H80V20zm0 10v-3.333h13.333V30H80zm3.333-25V3.333h10V5a5.006 5.006 0 0 1-5 5h-6.67a8.29 8.29 0 0 0 1.67-5zm-6.666 8.333V30h-10V13.333h10zm-26.667 0h13.333v3.334h-10V20h10v3.333h-10v3.334h10V30H50V13.333zm11.667 20h10V50h-10V33.333zm8.333 20h10V70H70V53.333zm-3.333 20h10V90h-10V73.333zM80 90v-3.333h13.333V90H80zm13.333-13.333H80v-3.334h13.333v3.334zm-10-6.667v-3.333h13.334V70H83.333z"
        fill="#000"
      />
    </g>
  </svg>
)

const Step3Graphic = () => (
  <svg width={100} height={100}>
    <g fillRule="nonzero" fill="none">
      <path
        d="M20.965 72.66v15.485c8.82.39 6.275 1.948 21.622 8.848 1.955.77 6.467 2.028 11.299-.192l.01-.004 30.149-10.795c.98-.451 5.93-3.14 3.978-8.148-2.282-5.34-8.155-3.112-8.647-2.952l-15.74 4.352"
        fill="#E4E5EA"
      />
      <path
        d="M38.773 79.138l17.529 5.555a5.759 5.759 0 0 0 7.114-3.964c.87-3.06-.905-6.244-4.41-7.545l-15.55-5.278c-.001 0-3.32-5.421-11.226-5.421-4.99 0-9.294 4.034-11.265 7.565v7.052"
        fill="#F7F8FF"
      />
      <path
        d="M31.787 78.878c-.127 0-.256-.014-.38-.04a1.892 1.892 0 0 1-.704-.29 1.87 1.87 0 0 1-.539-.54 1.806 1.806 0 0 1-.18-.338 1.924 1.924 0 0 1 .18-1.83 1.87 1.87 0 0 1 .54-.539 1.982 1.982 0 0 1 .702-.29 1.923 1.923 0 0 1 1.127.11 1.928 1.928 0 0 1 .877.72 1.982 1.982 0 0 1 .33 1.083 1.924 1.924 0 0 1-.15.746 1.928 1.928 0 0 1-.719.877 1.928 1.928 0 0 1-.703.291c-.125.026-.254.04-.38.04z"
        fill="#000"
      />
      <path fill="#EAECF0" d="M13.566 69.801h7.399v20.984h-7.399z" />
      <path fill="#00C389" d="M1.953 69.801h11.613v24.625H1.953z" />
      <path
        d="M89.842 77.145a1.895 1.895 0 0 0-.023-.058c-1.798-4.207-6.014-5.761-11.003-4.057l-13.607 3.763c-.787-2.383-2.75-4.41-5.524-5.44l-.052-.018-14.957-5.077c-1.245-1.609-5.145-5.726-12.446-5.726-5.102 0-9.616 3.5-12.199 7.315H1.953A1.953 1.953 0 0 0 0 69.801v24.624c0 1.079.874 1.953 1.953 1.953h11.613a1.953 1.953 0 0 0 1.953-1.953v-1.686h5.446a1.953 1.953 0 0 0 1.953-1.953v-.563c3.175.277 4.219.88 7.134 2.56 2.243 1.294 5.631 3.248 11.734 5.992.028.012.057.025.086.036 1.171.46 3.46 1.185 6.284 1.185 1.965 0 4.188-.351 6.47-1.386l30.077-10.769c.053-.019.106-.04.158-.064 2.874-1.323 7.158-5.05 4.981-10.632zm-78.23 15.327H3.907V71.754h7.707v20.718zm7.4-3.64h-3.493V71.754h3.493v17.078zM83.3 84.194L53.237 94.958a2.408 2.408 0 0 0-.167.068c-4.187 1.924-8.166.772-9.726.166-5.895-2.653-9.041-4.467-11.34-5.793-3.196-1.843-4.736-2.73-9.086-3.09v-15.73c1.851-3.035 5.442-6.141 9.312-6.141 6.638 0 9.45 4.317 9.561 4.491.239.388.605.68 1.037.827l15.522 5.268c2.48.93 3.79 3.054 3.187 5.17a3.78 3.78 0 0 1-1.808 2.284c-.88.49-1.898.612-2.868.344l-17.498-5.546A1.953 1.953 0 1 0 38.183 81l17.529 5.555.056.017a7.67 7.67 0 0 0 5.863-.681 7.66 7.66 0 0 0 3.783-5.102l14.664-4.063c2.118-.723 4.899-.984 6.136 1.867 1.282 3.347-2.048 5.188-2.914 5.601z"
        fill="#000"
      />
      <path fill="#00C389" d="M46.856 19.305L29.51 1.958 7.759 23.707l37.166 37.165L65.449 40.35" />
      <path
        d="M36.584 22.268a.263.263 0 0 0 .003-.012 9.18 9.18 0 0 0-5.862 15.65 9.18 9.18 0 0 0 15.67-6.26"
        fill="#FD0"
      />
      <path
        d="M79.035 30.338V14.852c-8.82-.39-6.275-1.948-21.622-8.848-1.955-.769-6.467-2.028-11.299.192a.14.14 0 0 1-.01.004l-9.096 3.257 9.386 9.386"
        fill="#E4E5EA"
      />
      <g fill="#00C389">
        <path d="M7.76 23.707l7.373-7.373c4.066 4.066 4.066 10.68 0 14.746L7.76 23.707zM37.552 53.499c4.066-4.066 10.68-4.066 14.746 0l-7.373 7.373-7.373-7.373zM22.135 9.331l7.374-7.373 7.373 7.373c-4.066 4.066-10.68 4.066-14.747 0zM56.876 35.556c-1.337 3.69-.528 7.987 2.425 10.94l6.148-6.147" />
      </g>
      <path
        d="M61.227 23.859l-17.529-5.555a5.758 5.758 0 0 0-7.114 3.964c-.87 3.06.905 6.244 4.41 7.545l15.557 5.28-.006-.002s3.319 5.422 11.225 5.422c4.991 0 9.294-4.035 11.265-7.566v-7.052"
        fill="#F7F8FF"
      />
      <path
        d="M68.213 28.026a1.924 1.924 0 0 1-.746-.15 1.928 1.928 0 0 1-.877-.72 1.928 1.928 0 0 1-.291-.702 1.924 1.924 0 0 1 .29-1.465 1.87 1.87 0 0 1 .54-.54 1.928 1.928 0 0 1 .703-.29 1.933 1.933 0 0 1 1.465.29 1.87 1.87 0 0 1 .539.54c.072.105.13.219.18.336a1.899 1.899 0 0 1 .15.748 1.922 1.922 0 0 1-.33 1.084 1.87 1.87 0 0 1-.54.539 1.982 1.982 0 0 1-1.083.33z"
        fill="#000"
      />
      <path fill="#EAECF0" d="M79.035 12.213h7.399v20.984h-7.399z" />
      <path fill="#00C389" d="M86.434 8.572h11.613v24.625H86.434z" />
      <path
        d="M98.047 6.62H86.434a1.953 1.953 0 0 0-1.953 1.952v1.687h-5.446a1.953 1.953 0 0 0-1.953 1.953v.562c-3.175-.277-4.219-.88-7.134-2.56-2.242-1.293-5.631-3.247-11.734-5.991a1.662 1.662 0 0 0-.086-.036c-1.987-.782-7.193-2.32-12.754.2l-7.86 2.814L30.89.577c-.763-.763-2-.763-2.762 0L6.378 22.326c-.703.704-.838 1.924 0 2.762l37.166 37.166c.594.595 1.987.775 2.762 0l19.856-19.857c.517.045 1.052.069 1.608.069 5.102 0 9.616-3.5 12.198-7.316h18.079A1.953 1.953 0 0 0 100 33.197V8.572a1.953 1.953 0 0 0-1.953-1.953zM34.463 24.732c.36 3 2.52 5.675 5.852 6.911l.052.019 3.905 1.325a7.196 7.196 0 0 1-1.944 3.538c-2.818 2.817-7.404 2.818-10.221 0-2.818-2.818-2.818-7.403 0-10.221a7.222 7.222 0 0 1 2.356-1.572zm3.907-7.626a7.656 7.656 0 0 0-3.183 3.361 11.13 11.13 0 0 0-5.843 3.075c-4.34 4.34-4.34 11.404 0 15.745a11.099 11.099 0 0 0 7.873 3.255 11.1 11.1 0 0 0 7.873-3.255 11.09 11.09 0 0 0 2.897-5.04l6.594 2.239a12.47 12.47 0 0 0 2.069 9.899l-4.46 4.46c-4.316-3.131-10.214-3.131-14.53 0L17.787 30.972a12.296 12.296 0 0 0 2.349-7.265c0-2.648-.823-5.168-2.349-7.265l4.457-4.457a12.295 12.295 0 0 0 7.265 2.349c2.648 0 5.168-.823 7.265-2.349L41 16.21c-.912.134-1.8.435-2.63.897zM59.464 43.57a8.543 8.543 0 0 1-1.248-4.062c.936.677 2.08 1.34 3.445 1.865l-2.197 2.197zM29.51 4.72L33.96 9.17a8.431 8.431 0 0 1-4.451 1.257 8.429 8.429 0 0 1-4.452-1.257L29.51 4.72zM14.973 19.255a8.431 8.431 0 0 1 1.256 4.452 8.43 8.43 0 0 1-1.256 4.452l-4.451-4.452 4.451-4.452zM44.925 58.11l-4.45-4.45a8.504 8.504 0 0 1 8.9 0l-4.45 4.45zM67.77 38.56c-.724 0-1.403-.052-2.038-.144l-.007-.001c-4.218-.613-6.487-3.01-7.235-3.96-.04-.058-.21-.28-.235-.317a1.946 1.946 0 0 0-1.076-.895l-15.53-5.27c-2.477-.93-3.787-3.053-3.187-5.17l.001-.003.002-.005a3.78 3.78 0 0 1 1.806-2.277 3.78 3.78 0 0 1 2.867-.343l17.5 5.545a1.953 1.953 0 1 0 1.18-3.724L47.9 17.586l-.121-.121-.004-.004-7.205-7.205 6.193-2.218.067-.025.02-.008.08-.034c4.186-1.925 8.166-.773 9.726-.166 5.895 2.652 9.041 4.467 11.34 5.792 3.196 1.843 4.736 2.732 9.086 3.09V32.42c-1.851 3.034-5.442 6.14-9.312 6.14zm13.218-24.395h3.493v17.079h-3.493V14.165zm15.106 17.079h-7.707V10.526h7.707v20.718z"
        fill="#000"
      />
    </g>
  </svg>
)

const Step4Graphic = () => (
  <svg width={100} height={100}>
    <g fillRule="nonzero" fill="none">
      <path
        d="M65 20c0 10.125-8.208 18.333-18.333 18.333-10.126 0-18.334-8.208-18.334-18.333 0-10.125 8.208-18.333 18.334-18.333C56.787 1.677 64.989 9.879 65 20z"
        fill="#FFDC00"
      />
      <path
        d="M46.667 1.666c-.837.007-1.672.07-2.5.19 9.071 1.234 15.839 8.975 15.85 18.13.01 9.155-6.739 16.912-15.807 18.167a18.333 18.333 0 1 0 2.457-36.487z"
        fill="#FEC108"
      />
      <path
        d="M98.333 51.317v12.366A3.333 3.333 0 0 1 95.367 67l-5.934.65a32.582 32.582 0 0 1-13.25 14.2l-1.066 14.933a1.685 1.685 0 0 1-1.667 1.55H63.217a1.685 1.685 0 0 1-1.667-1.55L60.9 87.5a34.77 34.77 0 0 1-15.133 0l-.65 9.283a1.685 1.685 0 0 1-1.667 1.55H33.217a1.685 1.685 0 0 1-1.667-1.55L30.483 81.85c-.333-.2-.65-.4-.966-.6-9.684-6.167-16.434-16.983-14-28.717 1.9-9.183 8.85-16.633 17.183-20.65A18.358 18.358 0 0 0 62.367 29.5a53.27 53.27 0 0 1 6.133 1.8c.117-.92.352-1.823.7-2.683a16.298 16.298 0 0 1 4.783-6.5c1.8-1.484 5.517-4.217 7.784-2.217A7.54 7.54 0 0 1 83.55 25c.322 2.309.361 4.648.117 6.967a10.88 10.88 0 0 1-1.967 5.2 30.362 30.362 0 0 1 7.733 10.183l5.934.65a3.333 3.333 0 0 1 2.966 3.317z"
        fill="#F8F9FF"
      />
      <path
        d="M41.667 38.333c.85-.001 1.7-.061 2.543-.18a18.293 18.293 0 0 1-11.51-6.27 35.053 35.053 0 0 0-3.232 1.784 18.233 18.233 0 0 0 12.199 4.666z"
        fill="#EAECF0"
      />
      <path
        d="M95.367 48l-5.934-.65A30.362 30.362 0 0 0 81.7 37.167a10.88 10.88 0 0 0 1.967-5.2A28.653 28.653 0 0 0 83.55 25a7.54 7.54 0 0 0-1.783-5.1c-1.334-1.18-3.179-.708-4.834.177A7.948 7.948 0 0 1 78.55 25c.322 2.309.361 4.648.117 6.967a10.88 10.88 0 0 1-1.967 5.2 30.362 30.362 0 0 1 7.733 10.183l5.934.65a3.333 3.333 0 0 1 2.966 3.317v12.366A3.333 3.333 0 0 1 90.367 67l-5.934.65a32.582 32.582 0 0 1-13.25 14.2l-1.066 14.933a1.685 1.685 0 0 1-1.667 1.55h5a1.685 1.685 0 0 0 1.667-1.55l1.066-14.933a32.582 32.582 0 0 0 13.25-14.2l5.934-.65a3.333 3.333 0 0 0 2.966-3.317V51.317A3.333 3.333 0 0 0 95.367 48zM40.767 87.5l-.65 9.283a1.685 1.685 0 0 1-1.667 1.55h5a1.685 1.685 0 0 0 1.667-1.55l.598-8.54a43.572 43.572 0 0 1-4.948-.743z"
        fill="#E7E9ED"
      />
      <path
        d="M95.547 46.343l-5.01-.548a31.653 31.653 0 0 0-6.704-8.887 13.293 13.293 0 0 0 1.5-4.741 30.805 30.805 0 0 0-.116-7.357l-.024-.208a8.615 8.615 0 0 0-2.333-5.964c-1.615-1.421-4.652-2.193-9.937 2.197a17.982 17.982 0 0 0-5.286 7.167c-.147.38-.244.76-.355 1.141a55.836 55.836 0 0 0-2.49-.74A19.968 19.968 0 0 0 46.667 0a19.824 19.824 0 0 0-10.915 3.24 1.668 1.668 0 0 0 1.833 2.787 16.5 16.5 0 0 1 9.082-2.694 16.657 16.657 0 0 1 6.036 32.195 34.755 34.755 0 0 0-12.055 0A16.598 16.598 0 0 1 30 20a16.393 16.393 0 0 1 1.817-7.572 1.667 1.667 0 1 0-2.965-1.523c-4.74 9.165-1.672 20.433 7.061 25.928a16.28 16.28 0 0 0-3.538 1.81 1.667 1.667 0 0 0 1.917 2.727 17.833 17.833 0 0 1 6.645-2.5h.046a31.122 31.122 0 0 1 11.367 0h.035a17.858 17.858 0 0 1 6.657 2.5 1.667 1.667 0 1 0 1.916-2.727 16.258 16.258 0 0 0-3.515-1.81 20.1 20.1 0 0 0 5.649-5.425 50.65 50.65 0 0 1 3.666 1.077c-.027.945.061 1.89.262 2.813a1.667 1.667 0 1 0 3.248-.746 9.032 9.032 0 0 1 .472-5.344 14.628 14.628 0 0 1 4.307-5.805c2.633-2.19 4.728-3.03 5.606-2.258a6.047 6.047 0 0 1 1.215 3.82l.024.213c.3 2.177.341 4.38.123 6.567A7.657 7.657 0 0 1 78.7 37.61a1.667 1.667 0 1 0 1.588 2.93 8.36 8.36 0 0 0 1.449-1.023 28.098 28.098 0 0 1 6.166 8.525c.244.533.75.899 1.334.963l5.931.65a1.667 1.667 0 0 1 1.482 1.667v12.366a1.667 1.667 0 0 1-1.482 1.667l-5.931.65a1.667 1.667 0 0 0-1.334.972 26.252 26.252 0 0 1-2.748 4.65 6.333 6.333 0 0 1-3.5-4.967 1.667 1.667 0 0 0-3.322.007 9.5 9.5 0 0 0 4.702 7.561 34.883 34.883 0 0 1-7.702 6.194 1.657 1.657 0 0 0-.805 1.31L73.45 96.667H63.213l-.65-9.284a1.667 1.667 0 0 0-1.968-1.523l-.29.053a32.707 32.707 0 0 1-13.943 0l-.29-.053a1.667 1.667 0 0 0-1.969 1.523l-.653 9.284H33.212l-1.067-14.934a1.667 1.667 0 0 0-.803-1.31 53.826 53.826 0 0 1-.93-.578c-10.119-6.443-15.325-17.032-13.264-26.972a27.345 27.345 0 0 1 10.029-15.565A1.667 1.667 0 0 0 25.1 34.7a30.695 30.695 0 0 0-11.217 17.5 24.818 24.818 0 0 0-.5 4.807c-1.106.073-2.183.145-3.22.18.06-.254.11-.512.149-.777a5.858 5.858 0 0 0-1.479-5.03A5.333 5.333 0 0 0 2.15 51a5.128 5.128 0 0 0-2.1 3.317 5.023 5.023 0 0 0 1.375 4.166 6.812 6.812 0 0 0 3.933 1.792 24.667 24.667 0 0 1-3.145 5.037 1.67 1.67 0 0 0 2.62 2.07 27.57 27.57 0 0 0 3.904-6.49l.155-.357c1.543 0 3.133-.103 4.686-.207 1.06 8.614 6.47 16.862 15.135 22.382l.175.11 1 14.092A3.355 3.355 0 0 0 33.222 100h10.233a3.36 3.36 0 0 0 3.333-3.1l.52-7.425c1.986.373 4.005.549 6.025.525a30.698 30.698 0 0 0 6.034-.525l.521 7.437A3.355 3.355 0 0 0 63.222 100h10.233a3.357 3.357 0 0 0 3.333-3.097l1-14.08a34.213 34.213 0 0 0 12.757-13.618l5-.548A5 5 0 0 0 100 63.683V51.317a5 5 0 0 0-4.453-4.974zM7.015 55.932a6.343 6.343 0 0 1-.3 1.166 4.715 4.715 0 0 1-2.882-.915 1.695 1.695 0 0 1-.49-1.371c.096-.452.365-.848.75-1.104.36-.248.79-.379 1.227-.375.432-.017.854.135 1.177.424.493.608.684 1.409.518 2.175z"
        fill="#000"
      />
      <path
        d="M81.667 48.333a1.667 1.667 0 0 0-3.334 0 3.333 3.333 0 1 1-6.666 0 1.667 1.667 0 0 0-3.334 0 6.667 6.667 0 0 0 13.334 0zM48.333 33.333v-.151A7.758 7.758 0 0 0 55 25.833a7.758 7.758 0 0 0-6.667-7.348v-8.228a4.292 4.292 0 0 1 3.334 3.91 1.667 1.667 0 0 0 3.333 0 7.758 7.758 0 0 0-6.667-7.349v-.151a1.667 1.667 0 1 0-3.333 0v.151a7.758 7.758 0 0 0-6.667 7.349A7.758 7.758 0 0 0 45 21.515v8.228a4.292 4.292 0 0 1-3.333-3.91 1.667 1.667 0 0 0-3.334 0A7.758 7.758 0 0 0 45 33.182v.151a1.667 1.667 0 0 0 3.333 0zm3.334-7.5a4.292 4.292 0 0 1-3.334 3.91v-7.82a4.292 4.292 0 0 1 3.334 3.91zm-10-11.666A4.292 4.292 0 0 1 45 10.257v7.82a4.292 4.292 0 0 1-3.333-3.91z"
        fill="#000"
      />
    </g>
  </svg>
)

const Homepage: React.FC<RouteComponentProps> = ({ navigate }) => {
  const [editableContent, setEditableContent] = useState<EditableHomepageContent>()

  useEffect(() => {
    const fetchAndSetEditableContent = () => {
      prismicClient
        .query(Prismic.Predicates.at("document.type", "homepage"), {})
        .then(({ results: [document] }) =>
          setEditableContent((document?.data as EditableHomepageContent) ?? null),
        )
    }
    fetchAndSetEditableContent()

    // Refresh the content every 5 minutes in case folks leave the page open
    const contentAutoRefreshInterval = setInterval(() => fetchAndSetEditableContent, 5 * 60 * 1000)

    return () => {
      clearInterval(contentAutoRefreshInterval)
    }
  }, [])

  return (
    <React.Fragment>
      <Helmet>
        <title>SevenCommas Home</title>
        <meta
          name="description"
          content="Calculate how much government Stimulus money your business can get. Finish your application in minutes."
        />
      </Helmet>

      <div css={[column, fullWidth, { padding: "50px 0" }]}>
        <div css={[siteContentContainer, column, fullWidth]}>
          <div css={[row, fullWidth, { alignItems: "center", justifyContent: "space-between" }]}>
            <div css={[column, yGap(20), { [MediaQuery.Mobile]: { alignItems: "center" } }]}>
              <div css={{ fontSize: 40, [MediaQuery.Mobile]: { textAlign: "center" } }}>
                Get Stimulus Funding to Pay Your Workers and Rent
              </div>
              <div css={{ fontSize: 18 }}>You may be eligible for more than you think</div>
              <div>
                <Button onClick={() => navigate && navigate("/calculator")}>
                  Calculate Your PPP Loan Amount
                </Button>
              </div>
              <Spacer height={30} />
            </div>
            <div
              css={{
                minWidth: "50%",
                textAlign: "right",
                [MediaQuery.Mobile]: { display: "none" },
              }}
            >
              <img css={{ width: "auto", maxWidth: "100%" }} src={heroImageSourceUrl} alt="" />
            </div>
          </div>
          <Spacer height={50} />
          <div css={[fullWidth, { fontSize: 40, textAlign: "center" }]}>How it Works</div>
          <Spacer height={80} />

          {/* Steps */}
          <div css={[row, flexCenterChildren]}>
            <div
              css={[
                row,
                {
                  // alignItems: "center",
                  maxWidth: "90%",
                  [MediaQuery.WideScreenOnly]: { maxWidth: "80%" },
                  [MediaQuery.Mobile]: { maxWidth: "100%" },
                },
              ]}
            >
              <div
                css={[
                  column,
                  yGap(30),
                  { width: "25%", alignItems: "center", [MediaQuery.Mobile]: yGap(10) },
                ]}
              >
                <Step1Graphic />
                <div css={{ fontSize: 22, textAlign: "center" }}>Apply</div>
              </div>
              <div
                css={[
                  column,
                  yGap(30),
                  { width: "25%", alignItems: "center", [MediaQuery.Mobile]: yGap(10) },
                ]}
              >
                <Step2Graphic />
                <div css={{ fontSize: 22, textAlign: "center" }}>Get Funding</div>
              </div>
              <div
                css={[
                  column,
                  yGap(30),
                  { width: "25%", alignItems: "center", [MediaQuery.Mobile]: yGap(10) },
                ]}
              >
                <Step3Graphic />
                <div css={{ fontSize: 22, textAlign: "center" }}>Pay Covered Expenses</div>
              </div>
              <div
                css={[
                  column,
                  yGap(30),
                  { width: "25%", alignItems: "center", [MediaQuery.Mobile]: yGap(10) },
                ]}
              >
                <Step4Graphic />
                <div css={{ fontSize: 22, textAlign: "center" }}>Have Your Loan Forgiven</div>
              </div>
            </div>
          </div>

          <Spacer height={100} />

          <div css={[column, flexCenterChildren]}>
            <Button onClick={() => navigate && navigate("/find-a-lender")}>
              Find the Right Lender Now
            </Button>
            <Spacer height={30} />
            <div css={{ textAlign: "center" }}>We contacted every lender so you don’t have to</div>
          </div>
        </div>

        <Spacer height={120} />

        {/* This component needs to span the full page width so the background can. The main
    content area is nested inside */}
        <div
          css={{
            backgroundImage: `url(${faqSectionBackgroundImageUrl})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
          }}
        >
          <div css={[siteContentContainer]}>
            {editableContent && (
              <div
                css={{
                  width: "60%",
                  margin: "auto",
                  textAlign: "center",

                  [MediaQuery.WideScreenOnly]: {
                    width: "50%",
                  },

                  [MediaQuery.Mobile]: {
                    width: "100%",
                  },

                  "& h1": {
                    marginTop: 80,
                    fontSize: 28,
                    fontWeight: 300,

                    [MediaQuery.Mobile]: {
                      marginTop: 50,
                    },
                  },

                  "& p": {
                    margin: "0",
                    marginBottom: 20,
                  },
                }}
              >
                <RichText render={editableContent.faq} />
              </div>
            )}
          </div>
        </div>

        <div css={[siteContentContainer]}></div>

        <Spacer height={200} />
      </div>
    </React.Fragment>
  )
}

export default Homepage
